import React, { useState, useEffect, useReducer, useRef } from "react";
import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Lookup,
  bar,
  AsyncRule,
  RequiredRule,
  FilterRow,
  Summary,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { CONFIG } from "../common/rps/config";

import ScrollView from "devextreme-react/scroll-view";
import rpsReducer from "../../reducers/rps";
import * as action from "../../actions/rps";
import ScatterChart from "./ScatterChart";
import { postUserLog } from "../../actions/common";
import { v4 as uuid } from "uuid";
import NEXUS_CONST from "../../common/constants";
import Button from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { alert } from "devextreme/ui/dialog";
import { postLogForFilter } from "./utils";
import { set, get, setGridUserPrefs, setGridWidthPrefs, applyUserPref, saveUserPref } from "../../common/utils";
import { isEmpty } from "lodash";

const initialStates = {
  solutionData: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: null,
  ophFile: null,
  peopleData: [],
  userPrefSps: null
};

const Solution = ({
  siteId,
  rpsID,
  handleSPSSave,
  chartId,
  setisOpen,
  tierId,
  navigationOn,
}) => {
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  const { peopleData } = state;
  const [isDisabled, setIsDisabled] = useState(true);
  const [solutiondata, setSolutiondata] = useState([]);
  const [rowVal, setRowVal] = useState(null);
  const dataGridRef = useRef(null);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
    const widgetId = 'saBox5'
    let { solutionData, rcaGridData, userPrefSps } = state;
    const GRID_COLS = JSON.stringify(["causeID", "rcaId", "solutionNameId", "solution", "expectedImprovement", "owner", "benefit", "difficulty", "pickStatus"]);
    const loggedinUser = get("hid");
    const PREF_KEY = 'userPref_' + widgetId
  const [distinctUsers, setDistinctUsers] = useState([]);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    setGridData(solutionData);
  }, [solutionData]);

  useEffect(() => {
    action.fetchSolutionData(dispatch, rpsID);
    action.fetchPeopleList(dispatch, siteId);
    action.fetchRCAGridData(dispatch, rpsID);
    AsyncCallHandler(NEXUS_CONST.FETCH_PS_DATA + rpsID, NEXUS_CONST.GET).then(
      (res) => {
        if (res) {
          setIsDisabled(res?.data?.status === "Complete");
        }
      }
    );
  }, []);

      useEffect(() => {
        action.fetchUserPref(
            dispatch,
            `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
        );
        return () => {
            action.updateUserPref(dispatch, saveUserPref({ widgetId, siteId, tierId, moduleName: 'DownTimeReason', loggedinUser, prefSess: PREF_KEY, GRID_COLS }));
        };
    }, []);

    useEffect(() => {
        if (userPrefSps) set(PREF_KEY, userPrefSps);
        if (dataGridRef && dataGridRef.current && dataGridRef.current.instance !== null && userPrefSps && gridData) {
            applyUserPref(dataGridRef, userPrefSps)
        }
    }, [userPrefSps, gridData])

  useEffect(() => {
    if (peopleData.length > 0) {
      populateDistinctUsersList();
    }
  }, [peopleData]);

  useEffect(() => {
    // if (solutionData && solutionData.length > 0) setIsDisabled(false);
  }, [solutionData]);
  const onDiff = (v) => {
    let rowInd = get("saActivI");
    let benefit = dataGridRef.current.instance.cellValue(rowInd, "benefit");
    dataGridRef.current.instance.cellValue(rowInd, "difficulty", v.value);
    if (benefit)
      dataGridRef.current.instance.cellValue(
        rowInd,
        "pickStatus",
        getPickState(benefit, v.value)
      );
  };
  const populateDistinctUsersList = () => {
    let _distinctUsers = [
      ...new Map(peopleData.map((ele) => [ele["employeeID"], ele])).values(),
    ];
    setDistinctUsers([..._distinctUsers]);
  };
  const getPickState = (b, d) => {
    let ps = "";
    if (b <= 5 && d <= 5) ps = "Possible";
    else if (b > 5 && d <= 5) ps = "Implement";
    else if (b <= 5 && d > 5) ps = "Kill";
    else if (b > 5 && d > 5) ps = "Challenge";
    return ps;
  };
  const updateRowIndx = (e) => {
    set("saActivI", e.rowIndex);
    setRowVal(e.rowIndex);
  };
  let RCAData = [];
  RCAData =
    rcaGridData?.length < 0 || rcaGridData === undefined ? [] : rcaGridData;

  const CauseIDDropdown = RCAData.map((e) => {
    return e.causeId;
  });

  let CauseIDDropdownFiltered = [...new Set(CauseIDDropdown)];

  let DD = RCAData.map((obj) => {
    return {
      value: `${obj.causeId}`,
      text: `${obj.cause}`,
    };
  });

  const onInitNewRow = React.useCallback((e) => {
    const numberOfRows =
      dataGridRef.current?.instance?.getVisibleRows()?.length || 0;

    e.data.rcaId = solutionData.rcaId;
    e.data.solution = "";
    e.data.solutionId = 0;
    e.data.solutionNameId = "PS" + rpsID + "-" + (numberOfRows + 1);
    e.data.expectedImprovement = "";
    e.data.owner = "";
    e.data.benefit = "";
    e.data.difficulty = "";
  }, []);

  const onRowUpdated = (data) => {
    let {
      id,
      rcaId,
      solution,
      solutionId,
      solutionNameId,
      expectedImprovement,
      owner,
      benefit,
      difficulty,
    } = data.data;

    let input = {
      id: rpsID,
      rcaId: rcaId.toString(),
      rpsId: rpsID?.toString(),
      solution: solution,
      solutionId: solutionId.toString(),
      solutionNameId: solutionNameId,
      expectedImprovement: expectedImprovement,
      owner: owner,
      benefit: benefit.toString(),
      difficulty: difficulty.toString(),
      pickStatus: getPickState(benefit, difficulty),
    };
  };
  const onRowInserted = (data) => {
    let {
      solution,
      rcaId,
      solutionNameId,
      expectedImprovement,
      owner,
      benefit,
      difficulty,
      causeID,
    } = data.data;

    let input = {
      id: 0,
      rpsId: rpsID.toString(),
      rcaId: causeID.toString(),
      solution: solution,
      solutionID: "0",
      solutionNameId: solutionNameId,
      expectedImprovement: expectedImprovement.toString(),
      owner: owner,
      benefit: benefit.toString(),
      difficulty: difficulty.toString(),
      pickStatus: getPickState(benefit, difficulty),
    };
  };

  
  const onBenefit = (v) => {
    let rowInd = get("saActivI");
    let diff = dataGridRef.current.instance.cellValue(rowInd, "difficulty");
    dataGridRef.current.instance.cellValue(rowInd, "benefit", v.value);
    if (diff)
      dataGridRef.current.instance.cellValue(
        rowInd,
        "pickStatus",
        getPickState(v.value, diff)
      );
  };

  const saveSps = () => {
    dataGridRef.current?.instance?.saveEditData();
    if (gridData.length === 0) {
      alert("Please add at least one solution", "Alert");
      return false;
    } else {
      let data = {
        rpsid: rpsID,
        solutionModel: gridData,
        section: navigationOn,
        lastSavedTab: "5",
        siteId: siteId,
        tierId: tierId,
      };

      AsyncCallHandler(
        NEXUS_CONST.POST_MANAGE_SOLUTIONAPPROCH,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
          action.fetchSolutionData(dispatch, rpsID);
          setisOpen("5");
        }
      });
    }
    handleSPSSave();
  };
  const renderCell = (data) => {
    let causeName = RCAData.find((c) => c.causeId == data.value);

    return (
      causeName && (
        <div title={`${causeName.causeId} - ${causeName.cause}`}>
          {causeName.causeId}
        </div>
      )
    );
  };
  //Function to show tool tip for the dropdown
  const onEditorPreparing = (e) => {
    if (e.dataField === "causeID" && e.parentType === "dataRow") {
      e.editorOptions.onOpened = (args) => {
        const lookupInstance = args.component;

        if (lookupInstance._list) {
          const $lookupItems = lookupInstance._list
            .$element()
            .find(".dx-list-item-content");

          $lookupItems.each((index, element) => {
            const itemData = DD[index];
            const tooltipText = `${itemData.value}-${itemData.text}`;
            element.setAttribute("title", tooltipText);
          });
        }
      };
    }
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated,
    };

    const isRcaIdVisible = () => {
        let cols = userPrefSps.filter
        if (!cols) return false;
        if (cols.indexOf('rcaId') > -1)
            return true;
        return false;
    }

  function handleGridOptionChanged(e) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Solution Approach",
      5,
      rpsID,
      navigationOn
    );
  }

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 5 - &nbsp;</span>Solution Approach
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveSps}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView
       width="100%"
       height="410px"
       {...scrollConfig} 
      >
        <div style={{  height: "420px", marginRight: "12px" }} >
          <div>
                      {(gridData && userPrefSps) && <DataGrid
                          ref={dataGridRef}
                          id="gridContainer"
                          dataSource={gridData}
                          columnAutoWidth={true}
                          allowColumnReordering={true}
                          onInitNewRow={onInitNewRow}
                          onCellClick={updateRowIndx}
                          showBorders={true}
                          {...CONFIG.RPS_EXPERIMENT}
                          onExporting={() =>
                              postUserLog({
                                  event: `Box 5 - Solution Approach Export`,
                                  data: {
                                      action: `Solution Approach exported for PS-${rpsID}`,
                                      module: "Digital Tier",
                                      section: navigationOn,
                                      siteUId: siteId,
                                      widget: "Structured Problem Solving",
                                      tierId,
                                  },
                              })
                          }
                          {...handlers}
                          wordWrapEnabled={true}
                          onEditorPreparing={onEditorPreparing}
                          width={"100%"}
                          onOptionChanged={handleGridOptionChanged}
                          onToolbarPreparing={function (e) {
                              var dataGrid = e.component;
                              var toolbarItems = e.toolbarOptions.items;
                              // Adds a new item
                              toolbarItems.unshift(
                                  {
                                      location: "before",
                                      template: "",
                                  },
                                  {
                                      location: "after",
                                      widget: "dxButton",
                                      options: {
                                          icon: "refresh",
                                          hint: "Refresh",
                                          onClick: function () {
                                              dataGrid.refresh();
                                              postUserLog({
                                                  event: `Box 5 - Solution Approach Refreshed`,
                                                  data: {
                                                      action: `Solution Approach refreshed for PS-${rpsID}`,
                                                      module: "Digital Tier",
                                                      section: navigationOn,
                                                      siteUId: siteId,
                                                      widget: "Structured Problem Solving",
                                                      tierId,
                                                  },
                                              });
                                          },
                                      },
                                  }
                              );
                          }}
                          onContentReady={e => setGridUserPrefs(e, widgetId)}
                          onColumnsChanging={e => setGridWidthPrefs(e, widgetId)}
                      >
                          <Paging enabled={false} />
                          <Editing mode="batch" allowUpdating={true} allowAdding={true} />
                          <FilterRow visible={true} />
                          <SearchPanel
                              visible={true}
                              onTextChange={(e) => {
                                  if (!isEmpty(e)) {
                                      postUserLog({
                                          event: "Box 5 - Solution Approach Grid Search",
                                          data: {
                                              action: `${e} searched in solution approach grid for PS-${rpsID}`,
                                              module: "Digital Tier",
                                              section: navigationOn,
                                              siteUId: siteId,
                                              widget: "Structured Problem Solving",
                                              tierId: tierId,
                                          },
                                      });
                                  }
                              }}
                          />
                          <Column
                              dataField="causeID"
                              caption="Cause #"
                              disable={true}
                              width={70}
                              cellRender={renderCell}
                              minWidth={20}
                          >
                              <Lookup dataSource={DD} valueExpr="value" displayExpr="value" />
                          </Column>

                          <Column
                              dataField="rcaId"
                              caption="RCA ID"
                              visible={isRcaIdVisible()}
                              minWidth={20}

                          ></Column>

                          <Column
                              dataField="solutionId"
                              caption="solutionId"
                              visible={false}
                              showInColumnChooser={false}
                              minWidth={20}
                          ></Column>
                          <Column
                              dataField="solution"
                              caption="Solution"
                              width={250}
                              cssClass="WrappedColumn"
                              minWidth={20}
                          >
                              {" "}
                              <RequiredRule />
                          </Column>
                          <Column
                              dataField="solutionNameId"
                              caption="Solution ID"
                              allowUpdating={false}
                              allowEditing={false}
                              width={300}
                              minWidth={20}
                              visible={true}

                          >
                              {" "}
                          </Column>
                          <Column
                              dataField="expectedImprovement"
                              caption="Expected Improvement"
                              cssClass="WrappedColumn"
                              width={300}
                              minWidth={20}
                          >
                              {" "}
                              <RequiredRule />
                          </Column>

                          <Column
                              dataField="owner"
                              caption="Owner"
                              width={120}
                              minWidth={20}
                          >
                              <Lookup
                                  dataSource={distinctUsers}
                                  valueExpr="employeeID"
                                  displayExpr="employeeName"
                              />
                              <RequiredRule />
                          </Column>

                          <Column
                              dataField="benefit"
                              caption="Benefit"
                              width={80}
                              editorOptions={{ onValueChanged: (v) => onBenefit(v) }}
                              minWidth={20}
                          >
                              <Lookup
                                  dataSource={NEXUS_CONST.BenefitData}
                                  valueExpr="value"
                                  displayExpr="value"
                              />{" "}
                              <RequiredRule />
                          </Column>

                          <Column
                              dataField="difficulty"
                              caption="Difficulty"
                              width={80}
                              minWidth={20}
                              editorOptions={{ onValueChanged: (v) => onDiff(v) }}
                          >
                              <Lookup
                                  dataSource={NEXUS_CONST.DifficultyData}
                                  valueExpr="value"
                                  displayExpr="value"
                              />{" "}
                              <RequiredRule />
                          </Column>
                          <Column
                              dataField="pickStatus"
                              caption="PICK Status"
                              allowUpdating={false}
                              allowEditing={false}
                              minWidth={20}
                          >
                              <Lookup
                                  dataSource={["Possible", "Implement", "Challenge", "Kill"]}
                              />{" "}
                              <RequiredRule />
                          </Column>

                          <Editing
                              mode="batch"
                              allowUpdating={true}
                              allowAdding={true}
                              allowDeleting={true}
                              useIcons={true}
                              width={50}
                          />
                      </DataGrid>}

            {solutionData && solutionData.length > 0 ? (
              <div className="soln_chart">
                <ScatterChart solutionData={solutionData} chartId={chartId} />
                {setisOpen("5")}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </ScrollView>
    </>
  );
};

export default Solution;
